import type { ReactNode } from 'react';

interface Props {
  label: string;
  value: string;
  hint?: string;
  icon: string;
  trend?: 'up' | 'down' | 'flat';
  trendLabel?: string;
  accent?: boolean;
  footer?: ReactNode;
}

export default function KpiCard({ label, value, hint, icon, trend, trendLabel, accent = false, footer }: Props) {
  return (
    <div className="flex flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="flex items-start justify-between gap-3">
        <p className="text-[11px] font-medium uppercase tracking-[0.1em] text-foreground-500">{label}</p>
        <span
          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md ${
            accent ? 'bg-accent-100 text-accent-700' : 'bg-primary-50 text-primary-700'
          }`}
        >
          <i className={`${icon} text-[15px]`} />
        </span>
      </div>
      <div className="mt-3">
        <p className="tnum text-[24px] font-semibold leading-7 text-foreground-950">{value}</p>
        <div className="mt-1 flex items-center gap-1.5 text-[11px]">
          {trend && trendLabel && (
            <span
              className={`inline-flex items-center gap-1 font-medium ${
                trend === 'up' ? 'text-primary-700' : trend === 'down' ? 'text-rose-600' : 'text-foreground-500'
              }`}
            >
              {trend !== 'flat' && (
                <i className={`${trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} text-[12px]`} />
              )}
              {trendLabel}
            </span>
          )}
          {hint && <span className="text-foreground-400">{hint}</span>}
        </div>
        {footer && <div className="mt-2">{footer}</div>}
      </div>
    </div>
  );
}